/* eslint-disable no-case-declarations, no-redeclare */
import {
  SET_DATA,
  SET_DATA_WITH_BRANCHES,
  UPDATE_INFORMATION,
  UPDATE_SHIPPING,
  UPDATE_SHIPPING_OPTION,
  UPDATE_BILLING,
  UPDATE_PAYMENT,
  UPDATE_SUMMARY,
  SET_FIELD_INFORMATION,
  SET_FIELD_COLORS,
  SET_CUSTOM_FIELD_INFORMATION,
  SET_FIELD_SHIPPING,
  SET_FIELD_PAYMENT,
  SET_FIELDS_LOCATIONS,
  SET_FIELDS_LOCATIONS_BILLING,
  SET_FIELD_BILLING,
  SET_FIELD_SUCCESS,
  ADD_SHIPPING_RATES,
  INCREASE_SHIPPING_RATES_COUNT,
  UPDATE_SHIPPING_RATES,
  ADD_SHIPPING_BRANCHES,
  SET_ADDRESS_AUTOFILL,
  ADD_ADDRESS_FOR_BRANCH_SEARCH,
} from "../actions/checkoutStore";

const initState = [];

export const checkoutStoreReducer = (checkoutStore = initState, action) => {
  // Avoid adding already loaded types
  if (
    action.type === ADD_SHIPPING_RATES &&
    checkoutStore.shipping.shipping_methods.length > 0
  ) {
    const newRateType = action.payload.rates.type;
    const sameTypeResult =
      checkoutStore.shipping.loaded_shipping_types.includes(newRateType);

    if (sameTypeResult) return { ...checkoutStore };
  }

  switch (action.type) {
    case SET_DATA:
      return {
        ...checkoutStore,
        information: {
          ...checkoutStore.information,
          ...action.payload.info,
        },
        shipping: {
          ...checkoutStore.shipping,
          ...action.payload.shipping,
        },
        billing: {
          ...checkoutStore.billing,
          ...action.payload.billing,
        },
        payment: {
          ...checkoutStore.payment,
          ...action.payload.payment,
        },
        success: {
          ...checkoutStore.success,
          ...action.payload.success,
        },
        colors: {
          ...checkoutStore.colors,
          ...action.payload.colors,
        },
        urls: {
          ...checkoutStore.urls,
          ...action.payload.urls,
        },
        legal_pages_urls: {
          ...checkoutStore.legal_pages_urls,
          ...action.payload.legal_pages_urls,
        },
        summary: {
          ...checkoutStore.summary,
          ...action.payload.summary,
        },
        system_fields: {
          ...checkoutStore.system_fields,
          ...action.payload.system_fields,
        },
        patterns: {
          ...checkoutStore.patterns,
          ...action.payload.patterns,
        },
        analytics_data: {
          ...checkoutStore.analytics_data,
          ...action.payload.analytics_data,
        },
        invoice_fields: {
          ...checkoutStore.invoice_fields,
          ...action.payload.invoice_fields,
        },
        jwt: action.payload.jwt,
      };
    case SET_DATA_WITH_BRANCHES:
      return {
        ...checkoutStore,
        information: {
          ...checkoutStore.information,
          ...action.payload.info,
        },
        shipping: {
          ...checkoutStore.shipping,
          ...action.payload.shipping,
          address_for_branch_search:
            checkoutStore.shipping?.address_for_branch_search,
          branches: checkoutStore.shipping?.branches, // <-- preserve existing branches
          pickup_point_id: checkoutStore.shipping?.pickup_point_id,
          pickup_point_name: checkoutStore.shipping?.pickup_point_name,
        },
        billing: {
          ...checkoutStore.billing,
          municipality: action.payload.shipping.municipality_code,
          ...action.payload.billing,
        },
        payment: {
          ...checkoutStore.payment,
          ...action.payload.payment,
        },
        success: {
          ...checkoutStore.success,
          ...action.payload.success,
        },
        colors: {
          ...checkoutStore.colors,
          ...action.payload.colors,
        },
        urls: {
          ...checkoutStore.urls,
          ...action.payload.urls,
        },
        legal_pages_urls: {
          ...checkoutStore.legal_pages_urls,
          ...action.payload.legal_pages_urls,
        },
        summary: {
          ...checkoutStore.summary,
          ...action.payload.summary,
        },
        system_fields: {
          ...checkoutStore.system_fields,
          ...action.payload.system_fields,
        },
        patterns: {
          ...checkoutStore.patterns,
          ...action.payload.patterns,
        },
        analytics_data: {
          ...checkoutStore.analytics_data,
          ...action.payload.analytics_data,
        },
        invoice_fields: {
          ...checkoutStore.invoice_fields,
          ...action.payload.invoice_fields,
        },
        jwt: action.payload.jwt,
      };
    case UPDATE_INFORMATION:
      return {
        ...checkoutStore,
        information: {
          ...checkoutStore.information,
          ...action.payload.info,
        },
        billing: {
          ...checkoutStore.billing,
          ...action.payload.billing,
        },
        shipping: {
          ...checkoutStore.shipping,
          ...action.payload.shipping,
        },
        summary: {
          ...checkoutStore.summary,
          ...action.payload.summary,
        },
      };
    case SET_ADDRESS_AUTOFILL:
      return {
        ...checkoutStore,
        information: {
          ...checkoutStore.information,
          ...action.payload.info,
        },
        billing: {
          ...checkoutStore.billing,
          ...action.payload.billing,
        },
      };
    case UPDATE_BILLING:
      return {
        ...checkoutStore,
        information: {
          ...checkoutStore.information,
          ...action.payload.info,
        },
        billing: {
          ...checkoutStore.billing,
          ...action.payload.billing,
        },
        payment: {
          ...checkoutStore.payment,
          ...action.payload.payment,
        },
        summary: {
          ...checkoutStore.summary,
          ...action.payload.summary,
        },
      };
    case UPDATE_SHIPPING:
      return {
        ...checkoutStore,
        shipping: {
          ...checkoutStore.shipping,
          ...action.payload.shipping,
          available: action.payload.summary != null,
        },
        summary: {
          ...checkoutStore.summary,
          ...action.payload.summary,
        },
      };
    case UPDATE_SHIPPING_OPTION:
      return {
        ...checkoutStore,
        information: {
          ...checkoutStore.information,
          shipping_option: action.payload.information.shipping_option,
        },
        shipping: {
          ...checkoutStore.shipping,
          ...action.payload.shipping,
        },
        summary: {
          ...checkoutStore.summary,
          ...action.payload.summary,
        },
      };
    case UPDATE_PAYMENT:
      return {
        ...checkoutStore,
        payment: {
          ...checkoutStore.payment,
          ...action.payload.payment,
        },
        summary: {
          ...checkoutStore.summary,
          ...action.payload.summary,
        },
      };
    case UPDATE_SUMMARY:
      return {
        ...checkoutStore,
        summary: {
          ...checkoutStore.summary,
          ...action.payload.summary,
        },
      };
    case SET_FIELD_INFORMATION:
      return {
        ...checkoutStore,
        information: {
          ...checkoutStore.information,
          [action.payload.field]: action.payload.value,
        },
      };
    case SET_FIELD_COLORS:
      return {
        ...checkoutStore,
        colors: {
          ...checkoutStore.colors,
          [action.payload.field]: action.payload.value,
        },
      };
    case SET_CUSTOM_FIELD_INFORMATION:
      var customFields = checkoutStore.information.custom_fields;
      customFields[action.payload.area] = customFields[action.payload.area].map(
        (cf, index) => {
          if (cf.custom_field_id == action.payload.field) {
            cf.value = action.payload.value;
          }

          return cf;
        },
      );

      return {
        ...checkoutStore,
        information: {
          ...checkoutStore.information,
          custom_fields: customFields,
        },
      };
    case SET_FIELD_SHIPPING:
      return {
        ...checkoutStore,
        shipping: {
          ...checkoutStore.shipping,
          [action.payload.field]: action.payload.value,
        },
      };
    case SET_FIELD_BILLING:
      return {
        ...checkoutStore,
        billing: {
          ...checkoutStore.billing,
          [action.payload.field]: action.payload.value,
        },
      };
    case SET_FIELD_PAYMENT:
      return {
        ...checkoutStore,
        payment: {
          ...checkoutStore.payment,
          [action.payload.field]: action.payload.value,
        },
      };
    case SET_FIELD_SUCCESS:
      return {
        ...checkoutStore,
        success: {
          ...checkoutStore.success,
          [action.payload.field]: action.payload.value,
        },
      };
    case SET_FIELDS_LOCATIONS:
      if (checkoutStore.information.billing_same_as_shipping)
        return {
          ...checkoutStore,
          information: {
            ...checkoutStore.information,
            ...action.payload.locations,
          },
          billing: {
            ...checkoutStore.billing,
            ...action.payload.locations,
          },
          system_fields: {
            ...checkoutStore.system_fields,
            ...action.payload.system_fields,
          },
        };
      else
        return {
          ...checkoutStore,
          information: {
            ...checkoutStore.information,
            ...action.payload.locations,
          },
          system_fields: {
            ...checkoutStore.system_fields,
            ...action.payload.system_fields,
          },
        };

    case SET_FIELDS_LOCATIONS_BILLING:
      return {
        ...checkoutStore,
        billing: {
          ...checkoutStore.billing,
          ...action.payload.locations,
        },
        system_fields: {
          ...checkoutStore.system_fields,
          ...action.payload.system_fields,
        },
      };
    case ADD_SHIPPING_RATES:
      var available = true;
      var selected_method = false;

      for (let i = 0; i < action.payload.rates.rates.length; i++) {
        if (
          checkoutStore.shipping.shipping_ids.shipping_method_id ===
            action.payload.rates.rates[i].table.shipping_method_id &&
          checkoutStore.shipping.shipping_ids.shipping_service_id ===
            action.payload.rates.rates[i].table.shipping_service_id
        ) {
          selected_method = true;
          available = action.payload.rates.rates[i].table.error === false;
        }
      }

      const coordinates =
        checkoutStore.information.coordinates?.length ||
        action.payload.rates.rates[0].table.shipping_address?.latitude == null
          ? checkoutStore.information.coordinates
          : [
              action.payload.rates.rates[0].table.shipping_address.latitude,
              action.payload.rates.rates[0].table.shipping_address.longitude,
            ];
      if (selected_method)
        return {
          ...checkoutStore,
          information: {
            ...checkoutStore.information,
            coordinates: coordinates,
          },
          shipping: {
            ...checkoutStore.shipping,
            loaded_shipping_types: [
              ...checkoutStore.shipping.loaded_shipping_types,
              action.payload.rates.type,
            ],
            shipping_methods: checkoutStore.shipping.shipping_methods
              .concat(action.payload.rates.rates)
              .sort(
                (a, b) => (a.table.position || 0) - (b.table.position || 0),
              ),
            available: available,
          },
          summary: {
            ...checkoutStore.summary,
            update_shipping: true,
          },
        };
      else
        return {
          ...checkoutStore,
          shipping: {
            ...checkoutStore.shipping,
            loaded_shipping_types: [
              ...checkoutStore.shipping.loaded_shipping_types,
              action.payload.rates.type,
            ],
            shipping_methods: checkoutStore.shipping.shipping_methods
              .concat(action.payload.rates.rates)
              .sort(
                (a, b) => (a.table.position || 0) - (b.table.position || 0),
              ),
            available: available,
          },
        };
    case INCREASE_SHIPPING_RATES_COUNT:
      return {
        ...checkoutStore,
        shipping: {
          ...checkoutStore.shipping,
          loaded_shipping_types: [
            ...checkoutStore.shipping.loaded_shipping_types,
            "",
          ],
        },
      };
    case UPDATE_SHIPPING_RATES:
      var available = true;

      for (let i = 0; i < action.payload.rates.rates.length; i++) {
        if (
          checkoutStore.shipping.shipping_ids.shipping_method_id ===
            action.payload.rates.rates[i].table.shipping_method_id &&
          checkoutStore.shipping.shipping_ids.shipping_service_id ===
            action.payload.rates.rates[i].table.shipping_service_id
        )
          available = action.payload.rates.rates[i].table.error === false;
      }

      const updated_shipping_methods =
        checkoutStore.shipping.shipping_methods.map((table) => {
          for (let i = 0; i < action.payload.rates.rates.length; i++) {
            if (table.table.id === action.payload.rates.rates[i].table.id)
              return action.payload.rates.rates[i];
          }

          return table;
        });

      return {
        ...checkoutStore,
        shipping: {
          ...checkoutStore.shipping,
          shipping_methods: updated_shipping_methods,
          available: available,
        },
      };
    case ADD_SHIPPING_BRANCHES:
      return {
        ...checkoutStore,
        shipping: {
          ...checkoutStore.shipping,
          branches: [
            ...(Array.isArray(checkoutStore.shipping.branches)
              ? checkoutStore.shipping.branches
              : []),
            ...action.payload.branches,
          ],
        },
      };
    case ADD_ADDRESS_FOR_BRANCH_SEARCH:
      return {
        ...checkoutStore,
        shipping: {
          ...checkoutStore.shipping,
          address_for_branch_search: action.payload.address,
        },
      };
    default:
      return checkoutStore;
  }
};
